import { render } from "./AutostartView.vue?vue&type=template&id=3c3bea3f&scoped=true"
import script from "./AutostartView.vue?vue&type=script&lang=js"
export * from "./AutostartView.vue?vue&type=script&lang=js"

import "./AutostartView.vue?vue&type=style&index=0&id=3c3bea3f&scoped=true&lang=css"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3bea3f"]])

export default __exports__